import type { AdminMe } from "@luckymenu/core";
import { createContext, useContext } from "react";

export const MeContext = createContext<AdminMe | null>(null);

/** The signed-in admin. Only available inside the gate. */
export function useMe(): AdminMe {
	const me = useContext(MeContext);
	if (!me) throw new Error("useMe outside AdminGate");
	return me;
}
